import customCallbackHandler from '../shared/customCallbackHandler';
const touchPress = customCallbackHandler.bind(null, 'Touch', 'touchPressCallback');
export default touchPress;
//# sourceMappingURL=touchPress.js.map